export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14264.9ab073fb.jpg";